/* eslint-disable object-curly-newline -- Exception to the rule, better readability without the extra new lines and indentation */

import { RelicData, View } from "enums";
import { MenuItemWithSubMenu, MenuItemWithView } from "views/page-parts/app-menu/types";


const app_menu:(MenuItemWithView | MenuItemWithSubMenu)[] = [
	{ header: "Home", view: View.HOME },
	{ header: "Characters", view: View.CHARACTERS },
	{ header: "Progress", view: View.PROGRESS },
	{ header: RelicData.Type.WEAPON, submenu: [
		{ header: RelicData.Group.WEAPON_ZODIAC, submenu: [
			{ header: "Overall", view: View.RELIC_WEAPONS_ZODIAC_OVERALL },
			{ header: RelicData.Part.WEAPON_BASE_WEAPON, view: View.RELIC_WEAPONS_ZODIAC_BASE_WEAPON },
			{ header: RelicData.Part.WEAPON_ZENITH, view: View.RELIC_WEAPONS_ZODIAC_ZENITH },
			{ header: RelicData.Part.WEAPON_ATMA, view: View.RELIC_WEAPONS_ZODIAC_ATMA },
			{ header: RelicData.Part.WEAPON_ANIMUS, view: View.RELIC_WEAPONS_ZODIAC_ANIMUS },
			{ header: RelicData.Part.WEAPON_NOVUS, view: View.RELIC_WEAPONS_ZODIAC_NOVUS },
			{ header: RelicData.Part.WEAPON_NEXUS, view: View.RELIC_WEAPONS_ZODIAC_NEXUS },
			{ header: RelicData.Part.WEAPON_BRAVES, view: View.RELIC_WEAPONS_ZODIAC_ZODIAC_BRAVES },
			{ header: RelicData.Part.WEAPON_ZETA, view: View.RELIC_WEAPONS_ZODIAC_ZODIAC_ZETA },
		]},
		{ header: RelicData.Group.WEAPON_ANIMA, submenu: [
			{ header: "Overall", view: View.RELIC_WEAPONS_ANIMA_OVERALL },
			{ header: RelicData.Part.WEAPON_ANIMATED, view: View.RELIC_WEAPONS_ANIMA_ANIMATED },
			{ header: RelicData.Part.WEAPON_AWOKEN, view: View.RELIC_WEAPONS_ANIMA_AWOKEN },
			{ header: RelicData.Part.WEAPON_ANIMA, view: View.RELIC_WEAPONS_ANIMA_ANIMA },
			{ header: RelicData.Part.WEAPON_HYPERCONDUCTIVE, view: View.RELIC_WEAPONS_ANIMA_HYPERCONDUCTIVE },
			{ header: RelicData.Part.WEAPON_RECONDITIONED, view: View.RELIC_WEAPONS_ANIMA_RECONDITIONED },
			{ header: RelicData.Part.WEAPON_SHARPENED, view: View.RELIC_WEAPONS_ANIMA_SHARPENED },
			{ header: RelicData.Part.WEAPON_COMPLETE, view: View.RELIC_WEAPONS_ANIMA_COMPLETE },
			{ header: RelicData.Part.WEAPON_LUX, view: View.RELIC_WEAPONS_ANIMA_LUX },
		]},
		{ header: RelicData.Group.WEAPON_EUREKA, submenu: [
			{ header: "Overall", view: View.RELIC_WEAPONS_EUREKA_OVERALL },
			{ header: RelicData.Part.WEAPON_ANTIQUATED, view: View.RELIC_WEAPONS_EUREKA_ANTIQUATED },
			{ header: RelicData.Part.WEAPON_ANEMOS, view: View.RELIC_WEAPONS_EUREKA_ANEMOS },
			{ header: RelicData.Part.WEAPON_ELEMENTAL, view: View.RELIC_WEAPONS_EUREKA_ELEMENTAL },
			{ header: RelicData.Part.WEAPON_PYROS, view: View.RELIC_WEAPONS_EUREKA_PYROS },
			{ header: RelicData.Part.WEAPON_EUREKA, view: View.RELIC_WEAPONS_EUREKA_EUREKA },
			{ header: RelicData.Part.WEAPON_PHYSEOS, view: View.RELIC_WEAPONS_EUREKA_PHYSEOS },
		]},
		{ header: RelicData.Group.WEAPON_RESISTANCE, submenu: [
			{ header: "Overall", view: View.RELIC_WEAPONS_RESISTANCE_OVERALL },
			{ header: RelicData.Part.WEAPON_RESISTANCE, view: View.RELIC_WEAPONS_RESISTANCE_RESISTANCE },
			{ header: RelicData.Part.WEAPON_AUGMENTED_RESISTANCE, view: View.RELIC_WEAPONS_RESISTANCE_AUGMENTED_RESISTANCE },
			{ header: RelicData.Part.WEAPON_RECOLLECTION, view: View.RELIC_WEAPONS_RESISTANCE_RECOLLECTION },
			{ header: RelicData.Part.WEAPON_LAWS_ORDER, view: View.RELIC_WEAPONS_RESISTANCE_LAWS_ORDER },
			{ header: RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER, view: View.RELIC_WEAPONS_RESISTANCE_AUGMENTED_LAWS_ORDER },
			{ header: RelicData.Part.WEAPON_BLADE, view: View.RELIC_WEAPONS_RESISTANCE_BLADE },
		]},
		{ header: RelicData.Group.WEAPON_MANDERVILLE, submenu: [
			{ header: "Overall", view: View.RELIC_WEAPONS_MANDERVILLE_OVERALL },
			{ header: RelicData.Part.WEAPON_MANDERVILLE, view: View.RELIC_WEAPONS_MANDERVILLE_MANDERVILLE },
			{ header: RelicData.Part.WEAPON_AMAZING_MANDERVILLE, view: View.RELIC_WEAPONS_MANDERVILLE_AMAZING_MANDERVILLE },
			{ header: RelicData.Part.WEAPON_MAJESTIC_MANDERVILLE, view: View.RELIC_WEAPONS_MANDERVILLE_MAJESTIC_MANDERVILLE },
			{ header: RelicData.Part.WEAPON_MANDERVILLOUS, view: View.RELIC_WEAPONS_MANDERVILLE_MANDERVILLOUS },
		]},
		{ header: RelicData.Group.WEAPON_PHANTOM, submenu: [
			{ header: "Overall", view: View.RELIC_WEAPONS_PHANTOM_OVERALL},
			{ header: RelicData.Part.WEAPON_PENUMBRAE, view: View.RELIC_WEAPONS_PHANTOM_PENUMBRAE},
			{ header: RelicData.Part.WEAPON_UMBRAE, view: View.RELIC_WEAPONS_PHANTOM_UMBRAE},
			{ header: RelicData.Part.WEAPON_OBSCURUM, view: View.RELIC_WEAPONS_PHANTOM_OBSCURUM},
			{ header: RelicData.Part.WEAPON_ECLIPTICUM, view: View.RELIC_WEAPONS_PHANTOM_ECLIPTICUM},
			{ header: RelicData.Part.WEAPON_OCCULTUM, view: View.RELIC_WEAPONS_PHANTOM_OCCULTUM},
		]},
	]},
	{ header: RelicData.Type.TOOL, submenu: [
		{ header: RelicData.Group.TOOL_LUCIS, submenu: [
			{ header: "Overall", view: View.RELIC_TOOLS_LUCIS_OVERALL },
			{ header: RelicData.Part.TOOL_MASTERCRAFT, view: View.RELIC_TOOLS_LUCIS_MASTERCRAFT },
			{ header: RelicData.Part.TOOL_SUPRA, view: View.RELIC_TOOLS_LUCIS_SUPRA },
			{ header: RelicData.Part.TOOL_LUCIS, view: View.RELIC_TOOLS_LUCIS_LUCIS },
		]},
		{ header: RelicData.Group.TOOL_SKYSTEEL, submenu: [
			{ header: "Overall", view: View.RELIC_TOOLS_SKYSTEEL_OVERALL },
			{ header: RelicData.Part.TOOL_SKYSTEEL, view: View.RELIC_TOOLS_SKYSTEEL_BASE_SKYSTEEL },
			{ header: RelicData.Part.TOOL_SKYSTEEL_1, view: View.RELIC_TOOLS_SKYSTEEL_SKYSTEEL_1 },
			{ header: RelicData.Part.TOOL_DRAGONSUNG, view: View.RELIC_TOOLS_SKYSTEEL_DRAGONSUNG },
			{ header: RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, view: View.RELIC_TOOLS_SKYSTEEL_AUGMENTED_DRAGONSUNG },
			{ header: RelicData.Part.TOOL_SKYSUNG, view: View.RELIC_TOOLS_SKYSTEEL_SKYSUNG },
			{ header: RelicData.Part.TOOL_SKYBUILDERS, view: View.RELIC_TOOLS_SKYSTEEL_SKYBUILDERS },
		]},
		{ header: RelicData.Group.TOOL_RESPLENDENT, view: View.RELIC_TOOLS_RESPLENDENT_RESPLENDENT },
		{ header: RelicData.Group.TOOL_SPLENDOROUS, submenu: [
			{ header: "Overall", view: View.RELIC_TOOLS_SPLENDOROUS_OVERALL },
			{ header: RelicData.Part.TOOL_SPLENDOROUS, view: View.RELIC_TOOLS_SPLENDOROUS_SPLENDOROUS },
			{ header: RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, view: View.RELIC_TOOLS_SPLENDOROUS_AUGMENTED_SPLENDOROUS },
			{ header: RelicData.Part.TOOL_CRYSTALLINE, view: View.RELIC_TOOLS_SPLENDOROUS_CRYSTALLINE },
			{ header: RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, view: View.RELIC_TOOLS_SPLENDOROUS_CHORA_ZOIS_CRYSTALLINE },
			{ header: RelicData.Part.TOOL_BRILLIANT, view: View.RELIC_TOOLS_SPLENDOROUS_BRILLIANT },
			{ header: RelicData.Part.TOOL_VRANDTIC_VISIONARYS, view: View.RELIC_TOOLS_SPLENDOROUS_VRANDTIC_VISIONARYS },
			{ header: RelicData.Part.TOOL_LODESTAR, view: View.RELIC_TOOLS_SPLENDOROUS_LODESTAR },
		]},
		{ header: RelicData.Group.TOOL_COSMIC, submenu: [
			{ header: "Overall", view: View.RELIC_TOOLS_COSMIC_OVERALL },
			{ header: RelicData.Part.TOOL_COSMIC, view: View.RELIC_TOOLS_COSMIC_COSMIC },
			{ header: RelicData.Part.TOOL_STELLAR, view: View.RELIC_TOOLS_COSMIC_STELLAR },
			{ header: RelicData.Part.TOOL_HYPER, view: View.RELIC_TOOLS_COSMIC_HYPER },
			{ header: RelicData.Part.TOOL_STARS, view: View.RELIC_TOOLS_COSMIC_STARS },
		]},
	]},
	/* TODO: Add in relic armour
	{ header: RelicType.ARMOUR, submenu: [
		{ header: RelicGroup.ARMOUR_ANEMOS, submenu: [
			{ header: "Overall", view: View.RELIC_ARMOUR_ANEMOS_OVERALL },
			{ header: RelicPart.ARMOUR_ANTIQUATED, view: View.RELIC_ARMOUR_ANEMOS_ANTIQUATED_ARMOUR },
			{ header: RelicPart.ARMOUR_BASE_0, view: View.RELIC_ARMOUR_ANEMOS_BASE_0 },
			{ header: RelicPart.ARMOUR_BASE_1, view: View.RELIC_ARMOUR_ANEMOS_BASE_1 },
			{ header: RelicPart.ARMOUR_BASE_2, view: View.RELIC_ARMOUR_ANEMOS_BASE_2 },
			{ header: RelicPart.ARMOUR_ANEMOS, view: View.RELIC_ARMOUR_ANEMOS_ANEMOS_ARMOUR },
		]},
		{ header: RelicGroup.ARMOUR_ELEMENTAL, submenu: [
			{ header: "Overall", view: View.RELIC_ARMOUR_ELEMENTAL_OVERALL },
			{ header: RelicPart.ARMOUR_ELEMENTAL, view: View.RELIC_ARMOUR_ELEMENTAL_ELEMENTAL_ARMOUR },
			{ header: RelicPart.ARMOUR_ELEMENTAL_1, view: View.RELIC_ARMOUR_ELEMENTAL_ELEMENTAL_1 },
			{ header: RelicPart.ARMOUR_ELEMENTAL_2, view: View.RELIC_ARMOUR_ELEMENTAL_ELEMENTAL_2 },
		]},
		{ header: RelicGroup.ARMOUR_BOZJAN, submenu: [
			{ header: "Overall", view: View.RELIC_ARMOUR_BOZJAN_OVERALL },
			{ header: RelicPart.ARMOUR_BOZJAN, view: View.RELIC_ARMOUR_BOZJAN_BOZJAN },
			{ header: RelicPart.ARMOUR_AUGMENTED_BOZJAN, view: View.RELIC_ARMOUR_BOZJAN_AUGMENTED_BOZJAN },
		]},
		{ header: RelicGroup.ARMOUR_LAWS_ORDER, submenu: [
			{ header: "Overall", view: View.RELIC_ARMOUR_LAWS_ORDER_OVERALL },
			{ header: RelicPart.ARMOUR_LAWS_ORDER, view: View.RELIC_ARMOUR_LAWS_ORDER_LAWS_ORDER },
			{ header: RelicPart.ARMOUR_AUGMENTED_LAWS_ORDER, view: View.RELIC_ARMOUR_LAWS_ORDER_AUGMENTED_LAWS_ORDER },
		]},
		{ header: RelicGroup.ARMOUR_BLADES, submenu: [
			{ header: "Overall", view: View.RELIC_ARMOUR_BLADES_OVERALL },
			{ header: RelicPart.ARMOUR_BLADES, view: View.RELIC_ARMOUR_BLADES_BLADES },
		]},
	]},
	*/
	{ header: "Items", view: View.ITEMS },
	// { header: "Tips", view: View.TIPS },// TODO: Add in tips
	{ header: "Gallery", view: View.GALLERY },
];

export default app_menu;
